import {
	Heading,
	PageContainer,
	PageTitle,
	Paragraph,
	AnchorProps,
	ThemeProvider,
	getAppropriateTheme,
} from '@mybonus/ui';

export type ErrorViewProps = {
	title: number;
	text: string;
	to: AnchorProps['to'];
};

// Note: This view does not have all providers that are available in normal app views.
export function ErrorView(props: ErrorViewProps) {
	return (
		<ThemeProvider theme={getAppropriateTheme()}>
			<PageContainer>
				<PageTitle>
					<Heading level={1}>{props.title} :(</Heading>
					<Paragraph size="lg">{props.text}</Paragraph>
				</PageTitle>
			</PageContainer>
		</ThemeProvider>
	);
}
